var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { padding: "0" }, attrs: { id: "classView" } },
    [
      _c(
        "v-overlay",
        { staticClass: "waitoverlay", attrs: { value: _vm.loading } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
        ],
        1
      ),
      _c("v-breadcrumbs", { attrs: { items: _vm.breadcrumbs, divider: "-" } }),
      _c(
        "v-card",
        { staticStyle: { padding: "0" } },
        [
          _c(
            "v-card-title",
            { staticClass: "mb-0" },
            [
              _c("date-range-picker", { on: { datesChange: _vm.datesChanged } })
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mr-4 ml-4" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v(_vm._s(_vm.$t("total-sessions")))
                          ]),
                          _c("v-card-text", [
                            _c("div", {
                              staticClass: "quota big",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatData(_vm.totalClassSessions)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v(_vm._s(_vm.$t("active-users")))
                          ]),
                          _c("v-card-text", [
                            _c("div", {
                              staticClass: "quota big",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatData(_vm.activeClassUsers)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v(_vm._s(_vm.$t("training-minutes")))
                          ]),
                          _c("v-card-text", [
                            _c("div", {
                              staticClass: "quota big",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatData(_vm.classTrainingMinutes)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _vm._v(_vm._s(_vm.$t("new-users")))
                          ]),
                          _c("v-card-text", [
                            _c("div", {
                              staticClass: "quota big",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatData(_vm.newClassUsers)
                                )
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("platform-usage", {
                        key: "platform-usage-" + _vm.platformUsageIndex,
                        attrs: {
                          id: "platformUsage",
                          "start-date": _vm.startDate,
                          "end-date": _vm.endDate,
                          scope: "class"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("module-survey-explorer", {
                        attrs: {
                          id: "successFactors",
                          "start-date": _vm.startDate,
                          "end-date": _vm.endDate,
                          "class-id": _vm.classId,
                          scope: "class"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }